import { inject } from '@angular/core';
import { HttpStatusCode } from '@angular/common/http';
import { ToastService } from '@core/toast/toast.service';
import { AuthorizationData, FeatureFlags, Permission, RequestFailure, ShellMethods } from '@kaseya-shared';
import { RemoteIntegrationShellMethods } from '@remote-integration';
import { AuthorizationService } from '@core/authorization/services/authorization.service';
import { SessionExpirationService } from '@core/authorization/services/session-expiration.service';
import { FeaturesFacade } from '@core/features/facades/features.facade';
import { PermissionsFacade } from '@core/permissions/facades/permissions.facade';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';

export const remoteIntegrationShellMethodsFactory = (): RemoteIntegrationShellMethods & ShellMethods => {
  const authorizationService = inject(AuthorizationService);
  const userInfoFacade = inject(UserInfoFacade);
  const sessionExpirationService = inject(SessionExpirationService);
  const permissionsFacade = inject(PermissionsFacade);
  const featuresFacade = inject(FeaturesFacade);
  const toastService = inject(ToastService);

  return {
    handleTokenRefreshed: async (authorizationData: AuthorizationData): Promise<void> => {
      authorizationService.setAuthorizationData(authorizationData);
      userInfoFacade.loadUserInfo();
    },
    handleTokenRefreshFailed: async (): Promise<void> => {
      await sessionExpirationService.expireSession();
    },
    handlePermissionsChanged: async (permissions: Permission[]): Promise<void> => {
      permissionsFacade.updatePermissions(permissions);
    },
    handleFeatureFlagsChanged: async (featureFlags: FeatureFlags): Promise<void> => {
      featuresFacade.updateFeatures(featureFlags);
    },
    handleRequestFailed: async (failure: RequestFailure): Promise<void> => {
      if (failure.kind === 'network-error') {
        toastService.showWarningToast('general-errors.server-not-respond');
        return;
      }

      toastService.showErrorToast(
        failure.status === HttpStatusCode.NotImplemented ? 'bis-migration.feature-unavailable' : 'general-errors.internal-server-error'
      );
    },
  };
};
